import { LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { classMap } from "lit/directives/class-map.js";
import styles from "./spinner.styles.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let Spinner = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = "large";
    this.progress = 25;
    this.isSpinning = false;
    this.color = "primary";
  }
  get boundingSize() {
    const sizeMap = { "x-small": 16, small: 20, large: 54 };
    return sizeMap[this.size];
  }
  get diameter() {
    return this.boundingSize - this.strokeWidth;
  }
  get radius() {
    return this.diameter / 2;
  }
  get centerPoint() {
    return this.boundingSize / 2;
  }
  get strokeWidth() {
    const sizeMap = { "x-small": 2, small: 2, large: 6 };
    return sizeMap[this.size];
  }
  get strokeDashArray() {
    return 2 * Math.PI * this.radius;
  }
  get strokeDashOffset() {
    return this.strokeDashArray - this.progress / 100 * this.strokeDashArray;
  }
  get progressClasses() {
    return { spinning: this.isSpinning };
  }
  get rootStyle() {
    return {
      "--spinner-stroke-width": `${this.strokeWidth}px`
    };
  }
  render() {
    return html`<svg class="spinner ${classMap({
      "spinner--primary": this.color === "primary",
      "spinner--bright": this.color === "bright"
    })}" part="base" aria-busy="true" aria-live="polite" width="${this.boundingSize}" height="${this.boundingSize}" viewBox="${`0 0 ${this.boundingSize} ${this.boundingSize}`}" version="1.1" xmlns="http://www.w3.org/2000/svg" style="${styleMap(this.rootStyle)}"><circle class="circle bg-circle" fill="none" r="${this.radius}" cx="${this.centerPoint}" cy="${this.centerPoint}" stroke-dasharray="${this.strokeDashArray}"></circle><circle class="circle progress-value ${classMap(this.progressClasses)}" fill="none" r="${this.radius}" cx="${this.centerPoint}" cy="${this.centerPoint}" stroke-dasharray="${this.strokeDashArray}" stroke-dashoffset="${this.strokeDashOffset}"></circle></svg>`;
  }
};
Spinner.styles = styles;
__decorateClass([
  property({ type: String, reflect: true })
], Spinner.prototype, "size", 2);
__decorateClass([
  property({ type: Number, reflect: true })
], Spinner.prototype, "progress", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], Spinner.prototype, "isSpinning", 2);
__decorateClass([
  property({ reflect: true })
], Spinner.prototype, "color", 2);
Spinner = __decorateClass([
  customElement("elm-spinner")
], Spinner);
export { Spinner as default };
